import { render, staticRenderFns } from "./commande.vue?vue&type=template&id=c58c3608&scoped=true&"
import script from "./commande.vue?vue&type=script&lang=js&"
export * from "./commande.vue?vue&type=script&lang=js&"
import style0 from "./commande.vue?vue&type=style&index=0&id=c58c3608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58c3608",
  null
  
)

export default component.exports